<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'My Prices'"
      [canGoBack]="true"
      [customBack]="windowService.isDesktopRes ? 'more/payment-options' : 'more'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="filtersForm">
    <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

      @if (loaded) {
        <tidy-card>
          <tidy-row>
            <tidy-text
              [header]="'Prices for Pros You Added'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'View price settings for pros you added'" /><span>&nbsp;</span>
              <tidy-text
                (action)="goToProSettingsPage()"
                [body]="'here'"
                class="link" />
              <tidy-text
                [body]="'.'" />
            </tidy-row>
          </tidy-card>
          <!--<tidy-row class="extra-bottom-padding">
          <tidy-filter
            formControlName="jobType"
            [items]="jobTypes"
            [fitContent]="true">
          </tidy-filter>
        </tidy-row>-->
        <tidy-card>
          <tidy-row>
            <tidy-text
              [header]="'Prices for Find New Pros'" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding">
            <tidy-text
              [body]="'These prices apply to job requests made to pros that you have not added, using the Find New Pro option. Higher prices tends to attract more/better pros for improved acceptance rates, quality, and reliability.'" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding">
            <tidy-select
              [icon]="'assets/svg/home.svg'"
              [label]="'Select Property'"
              [items]="addressList"
              [form]="filtersForm.controls.addressId"
              formControlName="addressId"
              (optionChange)="changeProperty()" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'Select Frequency'" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding">
            <tidy-radio-button
              formControlName="frequency"
              [form]="filtersForm.controls.frequency"
              [items]="frequencies" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'Select Billing Preference'" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding">
            <tidy-radio-button
              formControlName="chargeType"
              [form]="filtersForm.controls.chargeType"
              [items]="billingPreference" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding">
            <tidy-divider />
          </tidy-row>
          <tidy-row class="extra-bottom-padding">
            <tidy-text
              [body]="'<b>Your Current Selected Prices</b>'" />
          </tidy-row>
          @for (service of services; track service) {
            <tidy-row [alignLastItemRight]="true">
              <tidy-text
                [body]="service?.name" />
              <tidy-text
                [body]="getPrice(service)" />
            </tidy-row>
          }
          <tidy-row [align]="'center'">
            <tidy-text
              (action)="goToEditPricesPage()"
              [body]="'Edit Prices'"
              class="link" />
          </tidy-row>
          <tidy-error-message
            [text]="errorMessage" />
        </tidy-card>
        <tidy-row [align]="'center'">
          <tidy-text
            [helper]="'You have auto-bid enabled. These prices use auto-bid, which dynamically allocate your funds across cleaners and standbys, to improve reliability. You can set your price for anything. Just reach out to an account manager with any questions.'" />
        </tidy-row>
      }
    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
